import { render } from "./UserDropdown.vue?vue&type=template&id=799e5af5"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__